<template #content>
  <div>
    <div v-if="step === 2">
      <p class="text-medium-gray">{{(this.translation["3138"])}}</p><br/>
    </div>
    <div v-if="loading == true">
      <div class="spinner" style="margin-top:100px;"></div>
    </div>
    <div v-if="showForm == false">
      <div v-if="this.server_success" id="first_time_success" class="alert alert-success alert-register" style="margin-top:10px;">{{(this.translation["3028"])}}</div>
    </div>
    <div v-if="alreadySubmitted == true">
      <div id="alreadySubmitted" class="alert alert-info alert-register" style="margin-top:10px;">{{(this.translation["3028a"])}}</div>
    </div>
    <div v-if="showForm == true">
      <div v-if="this.errors == true" class="alert alert-danger alert-register">
        {{(this.translation["3143"])}}
      </div>
      <div v-if="this.server_error" id="first_time_error" class="alert alert-danger alert-register"><span>{{this.errorMessage}}</span><span style="display:block;">Please contact the FreightStation Helpdesk</span></div>
      <form>
        <!-- Step 1 -->
        <Transition name="step">
          <div v-if="step === 1">
            <div>
             
            </div>
          </div>
        </Transition>
        <!-- end Step 1 -->
        <!-- Step 2 -->
        <Transition name="step">
          <div v-if="step === 2">
            <div class="form-group row">
                <div class="col-lg-2">
                  <label>
                    {{(this.translation["3001"])}}*
                  </label>
                </div>
                <div class="col-lg-10">
                  <input v-model="companyName" name="companyName" :placeholder='(this.translation["3001"])' class="form-control" required />
                </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2">
                <label>
                  {{(this.translation["3002"])}}*
                </label>
              </div>
              <div class="col-lg-10">
                <input v-model="companyAddress" name="companyAddress" :placeholder='(this.translation["3002"])' class="form-control" required />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3003"])}}*</label></div>
              <div class="col-lg-4">
                <input v-model="companyZipcode" name="companyZipcode" :placeholder='(this.translation["3003"])' class="form-control" required />
              </div>
              <div class="col-lg-2"><label>{{(this.translation["3133"])}}*</label></div>
              <div class="col-lg-4">
                <input v-model="companyCity" name="companyCity" :placeholder='(this.translation["3133"])' class="form-control" required />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3005"])}}*</label></div>
              <div class="col-lg-4">
                <select name="companyCountry" class="form-control" @change="countryChange($event, $event.target.selectedIndex)" v-model="companyCountry" required>
                  <option value="" selected="selected">{{(this.translation["3142"])}}</option>
                  <option v-for="(item, key, index) in countriesTimezonesSorted" :key="index" :value="item.country_code">
                    {{item.name}}
                  </option>
                </select>
              </div>
              <div class="col-lg-2" v-if="companyCountry == 'US'"><label>{{(this.translation["3004"])}}*</label></div>
              <div class="col-lg-4" v-if="companyCountry == 'US'">
                <select v-model="companyState" name="companyState" class="form-control" @change="stateChange($event, $event.target.selectedIndex)" required>
                  <option value="" selected="selected">{{(this.translation["3142"])}}</option>
                  <option v-for="(item, key, index) in usStates" :key="index" :value="item.abbreviation">
                    {{item.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="countryTimezones.length > 1">
            <div class="col-lg-2"><label>{{(this.translation["3144"])}}</label></div>
              <div class="col-lg-6">
                <select name="companyCountry" class="form-control" v-model="timezone" required>
                  <option v-for="(item, key, index) in countryTimezones" :key="index" :value="item">
                    {{item.replace('_', ' ')}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3006"])}}*</label></div>
              <div class="col-lg-6"><vue-tel-input v-model="companyPhone" @validate="companyPhoneVal" id="companyPhone" ref="companyPhone" name='companyPhone' :autoFormat=true mode="international" :dropdownOptions ="{showDialCodeInList:true, showSearchBox:true, showFlags:true}" :preferredCountries=preferredCountries :validCharactersOnly=true :required=true></vue-tel-input></div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3007"])}}</label></div>
              <div class="col-lg-6"><input v-model="companyWebsite" name="companyWebsite" :placeholder='(this.translation["3007"])' class="form-control" /></div>
            </div>
          </div>
        </Transition>
        <!-- end Step 2 -->

        <!-- Step 3 -->
        <Transition name="step">
          <div v-if="step === 3">
            <div class="form-group row" v-if="![2, 3].includes(this.countryMappings[companyCountry]?.type || 0)">
              <div class="col-lg-6">
                <label>
                  <span><span v-if="govLabel">{{ govLabel }}</span><span v-else>{{ translation["3008"] }}</span>*</span> 
                </label>
              </div>
              <div class="col-lg-6">
                <input
                  v-model="companyGovRegNumber"
                  name="companyGovRegNumber"
                  :placeholder="govLabel || translation['3008']"
                  class="form-control"
                  required
                />
              </div>
            </div>

            <div class="form-group row" v-if="![1, 3].includes(this.countryMappings[companyCountry]?.type || 0)">
              <div class="col-lg-6">
                <label>
                  <span><span v-if="vatLabel">{{ vatLabel }}</span><span v-else>{{ translation["3009"] }}</span>*</span> 
                </label>
              </div>
              <div class="col-lg-6">
                <input
                  v-model="companyVat"
                  name="companyVat"
                  :placeholder="vatLabel || translation['3009']"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="form-group row" v-if="!['US', 'MX', 'CA', 'ZA'].includes(companyCountry)">
              <div class="col-lg-6"><label>{{(this.translation["3010"])}} {{ (this.translation["3010b"]) }}</label></div>
              <div class="col-lg-6"><input v-model="companyRaNumber" name="companyRaNumber" :placeholder='raLabel' class="form-control" /></div>
            </div>
            <div class="form-group row" v-if="this.countryMappings[this.companyCountry]?.EU">
              <div class="col-lg-6"><label>{{(this.translation["3010d"])}} {{ (this.translation["3010b"]) }}</label></div>
              <div class="col-lg-6"><input v-model="companyAhNumber" name="companyAhNumber" :placeholder='ahLabel' class="form-control" /></div>
            </div>
            <div class="form-group row">
              <div class="col-lg-6"><label>{{(this.translation["3010a"])}} {{ (this.translation["3010b"]) }}</label></div>
              <div class="col-lg-6"><input v-model="companyIataNumber" name="companyIataNumber" :placeholder='(this.translation["3010a"])' class="form-control" @keypress="isNumber($event)" @paste="convertToNumber($event)"/></div>
            </div>
            <div class="alert alert-info alert-register" style="margin-top:10px;">{{(this.translation["3148"])}}</div>
          </div>
        </Transition>
        <!-- end Step 3 -->

        <!-- Step 4 -->
        <Transition name="step">
          <div v-if="step === 4">
            <h4 class="modal-title" id="exampleModalLabel">{{(this.translation["3011"])}}</h4>
            <br/>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3012"])}}*</label></div>
              <div class="col-lg-4"><input v-model="companyAdminName" name="companyAdminName" :placeholder='(this.translation["3012"])' class="form-control" required/></div>
              <div class="col-lg-2"><label>{{(this.translation["3013"])}}*</label></div>
              <div class="col-lg-4"><input v-model="companyAdminSurname" name="companyAdminSurname" :placeholder='(this.translation["3013"])' class="form-control" required/></div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3014"])}}*</label></div>
              <div class="col-lg-4"><input v-model="companyJobTitle" name="companyJobTitle" :placeholder='(this.translation["3014"])' class="form-control" required/></div>
              <div class="col-lg-2"><label>{{(this.translation["3015"])}}</label></div>
              <div class="col-lg-4">
                <select name="companyGender" class="form-control" v-model="companyGender">
                  <option value="" selected="selected">{{(this.translation["3142"])}}</option>
                  <option value="M">{{(this.translation["3023"])}}</option>
                  <option value="F">{{(this.translation["3024"])}}</option>
                  <option value="X">{{(this.translation["3027"])}}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3016"])}}*</label></div>
              <div class="col-lg-10"><input type="email" v-model="companyEmail" name="companyEmail" :placeholder='(this.translation["3016"])' class="form-control" required/>
              <div class="warning-feedback" v-if="checkExtension(companyEmail)">
                <span class="glyphicon glyphicon-warning-sign"></span> {{(this.translation["3145"])}}
              </div>
              </div>

            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3018"])}}</label></div>
              <div class="col-lg-6"><vue-tel-input v-model="companyMobileNumber" @validate="companyMobileVal" id="companyMobileNumber" ref="companyMobileNumber" name='companyMobileNumber' :autoFormat=true mode="international" :dropdownOptions ="{showDialCodeInList:true, showSearchBox:true, showFlags:true}" :preferredCountries=preferredCountries :defaultCountry="preferredLang" :validCharactersOnly=true :required=true></vue-tel-input></div>
              <label><small>{{(this.translation["3018a"])}}</small></label>
            </div>
          </div>
        </Transition>
        <!-- end Step 4 -->

        <!-- step 5 -->
        <Transition name="step">
          <div v-if="step === 5">
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3020"])}}*</label></div>
              <div class="col-lg-10">
                <select name="companyAirport" class="form-control" v-model="companyAirport" required>
                  <option value="" selected="selected">{{(this.translation["3142"])}}</option>
                  <option v-for="(item, key, index) in filteredAirports" :key="index" :value="item.airportCommunity">
                    {{item.airportName + ' (' + item.airportIATA + ')'}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3019"])}}</label></div>
              <div class="col-lg-4">
                <select name="companyLanguage" class="form-control" v-model="companyLanguage">
                  <option value="en">English</option>
                  <option value="es">Espagnol</option>
                  <option value="fr">Français</option>
                  <option value="nl">Nederlands</option>
                  <option value="de">Deutsch</option>
                  <option value="it">Italiano</option>
                </select>
              </div>
              <!--
              <div class="col-lg-2"><label>{{(this.translation["3021"])}}</label></div>
              <div class="col-lg-4">
                <select name="companyType" class="form-control" v-model="companyType">
                  <option value="" selected="selected">{{(this.translation["3142"])}}</option>
                  <option value="agent">{{(this.translation["3025"])}}</option>
                  <option value="haulier">{{(this.translation["3026"])}}</option>
                  <option value="other">{{(this.translation["3027"])}}</option>
                </select>
              </div>-->
            </div>
            <div class="form-group row">
              <div class="col-lg-2"><label>{{(this.translation["3022"])}}</label></div>
              <div class="col-lg-10"><input v-model="companyRemarks" name="companyRemarks" :placeholder='(this.translation["3022"])' class="form-control" required/></div>
            </div>
          </div>
        </Transition>
        <!-- end step 5 -->
      </form>
      <div class="row">
        <div v-if="step !== 2" class="text-left col-sm-6"><button class="btn btn-info" type="button" @click="decrementStep">{{(this.translation["3139"])}}</button> </div>
        <div v-if="step === 2" class="text-left col-sm-6"></div>
        <div v-if="step !== 5" class="text-right col-sm-6"><button class="btn btn-info" type="button" @click="incrementStep" >{{(this.translation["3140"])}}</button> </div>
        <div v-if="step === 5" class="text-right col-sm-6"><button class="btn btn-info" type="button" @click="submit" >{{(this.translation["3141"])}}</button> </div>
      </div>
    </div>

  </div>
</template>

<style>
#firstTimeModal label {
  color: rgb(126.25, 126.25, 126.25);
  font-weight: 400 !important;
}
.step-enter {
  Opacity: 0;
}
.step-enter-active {
  transition : opacity 1s;
}
.step--leave {
  Opacity: 0;
}
.step-leave-active {
}

.alert-register {
  margin-top: -20px;
  margin-bottom: 20px;
}

.vue-tel-input {
  border-radius:2.5em;
}

.vti__input:not(.vti__search_box) {
  border-radius: 0 2.5em 2.5em 0;
}

.vti__dropdown {
  border-radius: 2.5em 0 0 2.5em;
}

.vti__dropdown-list {
  min-width:300px;
}

.vti__dropdown-item {
  padding: 3px 0px;
}

.vti__search_box {
  padding: 3px;
}

.needs-correction {
  border-color: #dc3545;
  padding-right: calc(1.5em + .75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(.375em + .1875rem) center;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}

.warning-feedback {
  color: #dc3545;
  font-size: .875em;
  margin-top: .25rem;
  width: 100%;
  padding-left: 15px;
  margin-top: 5px;
};

</style>
<script>
import countriesTimezones from "./data/countriesTimezones.json";
import usStates from "./data/usStates.json";
import countryRegNumbers from "./data/countryRegNumbers.json";
import {VueTelInput} from 'vue-tel-input';
const raRegex = /^[A-Z]{2}\/RA\/\d{5}-\d{2}$/;
const GENERIC_EMAIL_DOMAINS = new Set([
  // Google
  'gmail.com', 'googlemail.com',

  // Microsoft
  'outlook.com', 'hotmail.com', 'live.com', 'msn.com', 'passport.com',
  'outlook.fr', 'outlook.de', 'outlook.es', 'outlook.it', 'outlook.jp',
  'hotmail.co.uk', 'hotmail.fr', 'hotmail.de', 'hotmail.es', 'hotmail.it',
  'live.co.uk', 'live.fr', 'live.nl', 'live.com.au',

  // Yahoo / AOL / Verizon
  'yahoo.com', 'yahoo.co.uk', 'yahoo.fr', 'yahoo.de', 'yahoo.es', 'yahoo.it',
  'yahoo.co.jp', 'yahoo.co.in', 'yahoo.com.br', 'yahoo.ca', 'yahoo.com.au',
  'ymail.com', 'rocketmail.com', 'aol.com', 'aim.com', 'verizon.net',

  // Apple
  'icloud.com', 'me.com', 'mac.com',

  // Privacy-focused
  'protonmail.com', 'proton.me', 'pm.me', 'tutanota.com', 'tuta.com',
  'tuta.io', 'tutamail.com', 'mailfence.com', 'hushmail.com',
  'fastmail.com', 'fastmail.fm', 'runbox.com', 'posteo.de', 'posteo.net',
  'mailbox.org', 'startmail.com', 'countermail.com', 'cock.li',

  // Other global providers
  'zoho.com', 'zohomail.com', 'gmx.com', 'gmx.net', 'gmx.de', 'gmx.at',
  'mail.com', 'email.com', 'inbox.com', 'lycos.com', 'rediffmail.com',
  'excite.com', 'juno.com', 'netzero.net', 'cox.net', 'sbcglobal.net',
  'att.net', 'bellsouth.net', 'comcast.net', 'charter.net', 'earthlink.net',

  // Europe
  'wanadoo.com', 'wanadoo.fr', 'orange.fr', 'free.fr', 'laposte.net',
  'sfr.fr', 'neuf.fr', 'web.de', 't-online.de', 'freenet.de', 'arcor.de',
  'libero.it', 'virgilio.it', 'tiscali.it', 'alice.it', 'tin.it',
  'btinternet.com', 'sky.com', 'talktalk.net', 'blueyonder.co.uk',
  'ziggo.nl', 'kpnmail.nl', 'planet.nl', 'home.nl', 'xs4all.nl',
  'telenet.be', 'skynet.be', 'bluewin.ch', 'seznam.cz', 'centrum.cz',
  'wp.pl', 'o2.pl', 'onet.pl', 'interia.pl', 'op.pl',
  'telia.com', 'live.se', 'online.no', 'tele2.se',

  // Russia / CIS
  'yandex.com', 'yandex.ru', 'ya.ru', 'mail.ru', 'bk.ru', 'inbox.ru',
  'list.ru', 'rambler.ru', 'ukr.net',

  // Asia
  'qq.com', '163.com', '126.com', 'yeah.net', 'sina.com', 'sina.cn',
  'sohu.com', 'foxmail.com', '139.com', 'aliyun.com',
  'naver.com', 'daum.net', 'hanmail.net', 'nate.com',
  'docomo.ne.jp', 'ezweb.ne.jp', 'softbank.ne.jp', 'nifty.com',
  'rediff.com', 'sify.com',

  // Latin America / Africa / Middle East
  'uol.com.br', 'bol.com.br', 'terra.com.br', 'ig.com.br', 'globo.com',
  'terra.com', 'prodigy.net.mx', 'arnet.com.ar',
  'mweb.co.za', 'webmail.co.za',

  // Misc
  'gmx.us', 'usa.com', 'myway.com',

  // Mailinator
  'mailinator.com', 'mailinator.net', 'mailinator2.com', 'notmailinator.com',

  // Guerrilla Mail
  'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org',
  'guerrillamail.biz', 'guerrillamail.de', 'guerrillamailblock.com',
  'sharklasers.com', 'grr.la', 'spam4.me', 'pokemail.net',

  // 10 Minute Mail / Temp Mail
  '10minutemail.com', '10minutemail.net', '10minutemail.co.uk',
  'minuteinbox.com', 'temp-mail.org', 'temp-mail.io', 'tempmail.com',
  'tempmail.net', 'tempmailo.com', 'tempmailaddress.com', 'tempail.com',
  'tempr.email', 'tempinbox.com', 'tempmailer.com', 'temporary-mail.net',
  'mytemp.email', 'mail-temp.com', 'mailtemp.info',

  // YOPmail
  'yopmail.com', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf',
  'nospam.ze.tc', 'nomail.xl.cx', 'mega.zik.dj', 'speed.1s.fr',
  'courriel.fr.nf', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf',

  // 1secmail
  '1secmail.com', '1secmail.org', '1secmail.net', 'esiix.com', 'wwjmp.com',
  'xojxe.com', 'yoggm.com', 'kzccv.com', 'qiott.com', 'vjuum.com',
  'laafd.com', 'dpptd.com', 'oosln.com', 'icznn.com', 'ezztt.com',

  // Fake Mail Generator family
  'armyspy.com', 'cuvox.de', 'dayrep.com', 'einrot.com', 'fleckens.hu',
  'gustr.com', 'jourrapide.com', 'rhyta.com', 'superrito.com',
  'teleworm.us', 'fakemailgenerator.com',

  // Trashmail / Throwaway
  'trashmail.com', 'trashmail.net', 'trashmail.de', 'trashmail.me',
  'trash-mail.com', 'wegwerfmail.de', 'wegwerfmail.net', 'wegwerfmail.org',
  'throwawaymail.com', 'throwam.com', 'trbvm.com',

  // Other well-known services
  'getnada.com', 'nada.email', 'maildrop.cc', 'dispostable.com',
  'fakeinbox.com', 'fakemail.net', 'emailfake.com', 'mailnesia.com',
  'mintemail.com', 'mohmal.com', 'emailondeck.com', 'burnermail.io',
  'mailcatch.com', 'discard.email', 'discardmail.com', 'discardmail.de',
  'spamgourmet.com', 'spambox.us', 'spamex.com', 'spamfree24.org',
  'spamavert.com', 'mailnull.com', 'anonbox.net', 'harakirimail.com',
  'incognitomail.com', 'instantemailaddress.com', 'meltmail.com',
  'mailmoat.com', 'owlymail.com', 'moakt.com', 'tmpmail.org',
  'tmpmail.net', 'dropmail.me', 'mailpoof.com', 'inboxkitten.com',
  'mailsac.com', 'emailtemporanea.net', 'crazymailing.com',
  'getairmail.com', 'mailforspam.com', 'filzmail.com', 'jetable.org',
  'mt2015.com', 'mailexpire.com', 'mailzilla.com', 'sute.jp',
  'bccto.me', 'tafmail.com', 'zetmail.com',
]);

// Brand names that have many regional variants (yahoo.co.nz, hotmail.com.br, ...).
// Matched against the domain only, never the local part of the address.
const GENERIC_BRAND_KEYWORDS = ['gmail', 'yahoo', 'hotmail', 'outlook'];

export default {
  name: 'Register',
  components: {
      VueTelInput
    },
  props:['trans'],
  data() {
    return{
      step: 2,
      companyName: '',
      companyAddress: '',
      companyZipcode: '',
      companyState: '',
      companyCountry: '',
      companyPhone: '',
      companyWebsite: '',
      companyGovRegNumber: '',
      companyVat: '',
      companyRaNumber: '',
      companyAhNumber: '',
      companyIataNumber: '',
      companyAdminName: '',
      companyAdminSurname: '',
      companyJobTitle: '',
      companyGender: '',
      companyEmail: '',
      companyMobileNumber: '',
      companyAirport: '',
      companyLanguage: '',
      companyType: '',
      companyRemarks: '',
      companyCity: '',
      timezone: '',
      errors: [],
      server_success: false,
      server_error: false,
      alreadySubmitted: false,
      errorMessage: "",
      translation: [],
      showForm: true,
      loading: false,
      countriesTimezones: countriesTimezones,
      usStates: usStates,
      airports: airports,
      countryMappings: countryRegNumbers, // Type 0: both fields, type 1: only gov reg, type 2: only vat, type 3: custom field
      countryTimezones: '',
      preferredCountries: ['es','de','nl','at','be','fr','us','it','gb','ie','dk','ch'],
      preferredLang: 'US',
    }
  },
  created(){
    this.setTranslation()
    this.showForm = true
    this.loading = false
    this.companyLanguage = this.translation["code"]
    let _this = this
    $('#firstTimeModal').on('shown.bs.modal', function () {
      _this.cleanForm();
      _this.showForm = true
      _this.step = 1

    });

  },
  watch: {
    companyGovRegNumber(newVal) {
      if (!this.countryMappings[this.companyCountry]) return;
      const countryType = this.countryMappings[this.companyCountry].type;
      if (countryType === 1) {
          this.companyVat = newVal;
      }
    },
    companyVat(newVal) {
      if (!this.countryMappings[this.companyCountry]) return;
      const countryType = this.countryMappings[this.companyCountry].type;
      if (countryType === 2) {
        this.companyGovRegNumber = newVal;
      }
    },
    companyRaNumber(newVal) {
      if (this.countryMappings[this.companyCountry]?.EU || this.companyCountry == 'GB') {
        this.companyRaNumber = this.formatRaNumber(newVal);
      };
    },
    companyAhNumber(newVal) {
      if (this.countryMappings[this.companyCountry]?.EU) {
        this.companyAhNumber = this.formatAhNumber(newVal);
      };
    }
  },
  mounted() {
  },
  computed: {
    govLabel() {
      return this.countryMappings[this.companyCountry]?.govLabel || this.translation['3008a'] || '';
    },
    vatLabel() {
      return this.countryMappings[this.companyCountry]?.vatLabel || this.translation['3009'] || '';
    },
    raLabel() {
      if (this.countryMappings[this.companyCountry]?.EU || this.companyCountry == 'GB') {
        return this.companyCountry + "/RA/00000-00";
      }
      return this.translation["3010"];
    },
    ahLabel() {
      if (this.countryMappings[this.companyCountry]?.EU) {
        return this.companyCountry + "/AH/00000";
      }
      return this.translation["3010d"];
    },
    countriesTimezonesSorted: function() {
      return this.countriesTimezones.sort((t1,t2) => t1.name < t2.name ? -1 : 1);
    },
    filteredAirports() {
      return this.airports.filter(item => item.airportCommunity !== null);
    },
  },
  methods:{
    async submit() {
      if (!this.companyAirport && this.step == 5) {
        this.errors = true;
        $('select[name="companyAirport"]').addClass('needs-correction');
      } else {
        if (this.countryMappings[this.companyCountry]?.EU) { // SET EU VAT PREFIX
          const countryCode = this.companyCountry;
          if (!this.companyVat.startsWith(countryCode)) {
            this.companyVat = countryCode + this.companyVat;
          }
          if (this.companyGovRegNumber.startsWith(countryCode)) {
            this.companyGovRegNumber = this.companyGovRegNumber.slice(2);
          }
        }
        this.loading = true
        this.showForm = false;
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json",'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            "_token": document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            form: {
              "companyName": this.companyName,
              "companyAddress": this.companyAddress,
              "companyZipcode": this.companyZipcode,
              "companyState": this.companyState,
              "companyCountry": this.companyCountry,
              "companyPhone": this.companyPhone,
              "companyWebsite": this.companyWebsite,
              "companyGovRegNumber": this.companyGovRegNumber.toUpperCase(),
              "companyVat": this.companyVat.toUpperCase(),
              "companyRaNumber": this.companyRaNumber + ',' + this.companyAhNumber,
              "companyIataNumber": this.companyIataNumber,
              "companyAdminName": this.companyAdminName,
              "companyAdminSurname": this.companyAdminSurname,
              "companyJobTitle": this.companyJobTitle,
              "companyGender": this.companyGender,
              "companyEmail": this.companyEmail.endsWith("#") 
                ? this.companyEmail.slice(0, -1) 
                : this.companyEmail, 
              "companyMobileNumber": this.companyMobileNumber,
              "companyAirport": this.companyAirport,
              "companyLanguage": this.companyLanguage,
              "companyType": this.companyType,
              "companyRemarks": this.companyRemarks,
              "companyCity": this.companyCity,
              "timezone": this.timezone,
            }
          })
        };
        const response = await fetch("/register_company", requestOptions)
        if(response.status == 422) {
          this.loading = false;
          this.alreadySubmitted = true;
          this.server_success = false;
          this.showForm = false;
          return;
        } else {
          this.alreadySubmitted = false;
        };
        if( response.ok == false) {
          this.loading = false;
          this.server_error = true;
          this.errorMessage = response.statusText;
          this.server_success = false;
          this.showForm = true;
          return;
        };
        const result = await response.json();
        this.loading = false
        if( result.error == false) {
          this.server_error = false;
          this.errorMessage = "";
          this.server_success = true;
          this.cleanForm();
          this.showForm = false;
        } else {
          this.server_error = true;
          this.errorMessage = result.message;
          this.server_success = false;
          this.showForm = true;
        }
      };
    },
    countryChange(event, selectedIndex) {
        this.preferredLang = event.target.value;
        if(this.preferredLang != 'US') {
          this.companyState = "";
        }
        if(selectedIndex > 0) {
          if(!(this.preferredLang == 'US' && !this.companyState)) {
            this.countryTimezones = countriesTimezones[selectedIndex - 1].timezones;
            this.timezone = this.countryTimezones[0];
          }else {
            this.countryTimezones = [];
            this.timezone = null;
          }; 
        } else {
          this.countryTimezones = [];
          this.timezone = null;
        };
        if(this.companyPhone == '' && this.$refs.companyPhone) {
          this.$refs.companyPhone.choose(this.preferredLang);
        }
    },
    stateChange(event, selectedIndex) {
      if(selectedIndex > 0) {
        this.countryTimezones = usStates[selectedIndex - 1].ianaTimezones;
        this.timezone = this.countryTimezones[0];
      } else {
        this.countryTimezones = [];
        this.timezone = null;
      }
    },
    isNumber: function(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keyPressed = evt.key;
      
      if (!keysAllowed.includes(keyPressed)) {
            evt.preventDefault()
      }
    },
    convertToNumber: function(evt) {
      const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      const keyPressed = evt.clipboardData.getData('text/plain');
      const clipboardData = evt.clipboardData.getData('text/plain');
      const clipboardDataArray = clipboardData.split('');
      const clipboardDataArrayFiltered = clipboardDataArray.filter((char) => keysAllowed.includes(char));
      const clipboardDataFiltered = clipboardDataArrayFiltered.join('');
      evt.preventDefault();
      evt.target.value = clipboardDataFiltered;
    },
    companyPhoneVal: function(object) {
      if (object.valid === true) {
        this.companyPhoneValue = true;
      } else {
        this.companyPhoneValue = false;
      }
    },
    companyMobileVal: function(object) {
      if (object.valid === true) {
        this.companyMobileValue = true;
      } else {
        this.companyMobileValue = false;
      }
    },
    setTranslation(){
      this.translation = this.trans;
    },
    cleanForm() {
      this.companyName = "";
      this.companyAddress = "";
      this.companyZipcode = "";
      this.companyState = "";
      this.companyCountry = "";
      this.companyPhone = "";
      this.companyPhoneValue ="false";
      this.companyWebsite = "";
      this.companyGovRegNumber = "";
      this.companyVat = "";
      this.companyRaNumber = "";
      this.companyAhNumber = "";
      this.companyIataNumber = "";
      this.companyAdminName = "";
      this.companyAdminSurname = "";
      this.companyJobTitle = "";
      this.companyGender = "";
      this.companyEmail = "";
      this.companyMobileNumber = "";
      this.companyMobileValue ="false";
      this.companyAirport = "";
      this.companyLanguage = "";
      this.companyType = "";
      this.companyRemarks = "";
      this.companyCity = "";
      this.timezone = "";
    },
    setErrors: function () {
      this.errors = false;
      $('.needs-correction').removeClass('needs-correction');

      if (!this.companyName && this.step == 2) {
        this.errors = true;
        $('input[name="companyName"]').addClass('needs-correction');
      }
      if (!this.companyAddress && this.step == 2) {
        this.errors = true;
        $('input[name="companyAddress"]').addClass('needs-correction');
      }
      if (!this.companyZipcode && this.step == 2) {
        this.errors = true;
        $('input[name="companyZipcode"]').addClass('needs-correction');
      }
      if (!this.companyCity && this.step == 2) {
        this.errors = true;
        $('input[name="companyCity"]').addClass('needs-correction');
      }
      if (!this.companyCountry && this.step == 2) {
        this.errors = true;
        $('select[name="companyCountry"]').addClass('needs-correction');
      }
      if (!this.companyState && this.companyCountry == "US" && this.step == 2) {
        this.errors = true;
        $('select[name="companyState"]').addClass('needs-correction');
      }
      if (!this.companyPhoneValue && this.step == 2) {
        this.errors = true;
        $('#companyPhone').addClass('needs-correction');
      }
      if (this.companyGovRegNumber.length < 6 && this.step == 3) {
        this.errors = true;
        $('input[name="companyGovRegNumber"]').addClass('needs-correction');
      }
      if (this.companyVat.length < 6 && this.step == 3) {
        this.errors = true;
        $('input[name="companyVat"]').addClass('needs-correction');
      }
      if ((this.countryMappings[this.companyCountry]?.EU || this.companyCountry == 'GB') && this.step == 3 && this.companyRaNumber) {

        if (!raRegex.test(this.companyRaNumber)) {
          this.errors = true;
          $('input[name="companyRaNumber"]').addClass('needs-correction');
        } else {
          this.errors = false;
          $('input[name="companyRaNumber"]').removeClass('needs-correction');
        }
      }
      if (!this.companyAdminName && this.step == 4) {
        this.errors = true;
        $('input[name="companyAdminName"]').addClass('needs-correction');
      }
      if (!this.companyAdminSurname && this.step == 4) {
        this.errors = true;
        $('input[name="companyAdminSurname"]').addClass('needs-correction');
      }
      if (!this.companyJobTitle && this.step == 4) {
        this.errors = true;
        $('input[name="companyJobTitle"]').addClass('needs-correction');
      }
      if (!this.validateEmail(this.companyEmail) && this.step == 4) {
        this.errors = true;
        $('input[name="companyEmail"]').addClass('needs-correction');
      }
      if (!this.companyMobileValue && this.step == 4) {
        this.errors = true;
        $('#companyMobileNumber').addClass('needs-correction');
      }
    },
    handleIncrement: function () {
      this.errors = false;
      let self = this
      switch (this.step) {
        case 1:
          if (this.companyName) {
            this.step = this.step + 1;
          } else {
            this.setErrors();
          }
          break;
        case 2:
          if(this.companyCountry == 'US' && !this.companyState) {
            var stateFilled = false;
          } else {
            var stateFilled = true;
          }
          if (this.companyAddress && this.companyZipcode && this.companyCity && this.companyCountry && stateFilled && this.companyPhoneValue && this.companyName) {
            this.step = this.step + 1;
          } else {
            this.setErrors();
          }
          break;
        case 3:
          if (this.companyGovRegNumber.length > 5 && this.companyVat.length > 5 && ((!this.countryMappings[this.companyCountry]?.EU && this.companyCountry != 'GB') || raRegex.test(this.companyRaNumber) || !this.companyRaNumber)) {
            this.step = this.step + 1;
          } else {
            this.setErrors();
          }
          break;
        case 4:
          if (this.companyAdminName && this.companyAdminSurname && this.companyJobTitle && this.validateEmail(this.companyEmail) && this.companyMobileValue) {
            this.step = this.step + 1;
          } else {
            this.setErrors();
          }
          break;
        case 5:
          if(this.companyAirport) {
            this.step = this.step + 1;
          } else {
            this.setErrors();
          }
          break;
      }
    },
    incrementStep() {
      this.handleIncrement();
    },
    handleDecrement: function () {
      this.errors = false;
      this.step = this.step - 1;
    
    },
    decrementStep() {
      this.handleDecrement();
    },
    validateEmail(mail) {
    var validMail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // If ends with "#", only validate with regex
    if (mail.endsWith("#")) {
        return validMail.test(mail.slice(0, -1)); // remove "#" before regex test
    }

    // Otherwise, do regex + extension check
    if (validMail.test(mail) && !this.checkExtension(mail)) {
        return true;
    } else {
        return false;
    }
    },
  formatRaNumber(input) {
      if (!input) return '';

      let value = input.toUpperCase();

      let match = value.match(/^([A-Z]{2})\/?RA\/?/i);
      let prefix;

      if(match && !/^[0-9]+$/.test(value) && value.length == 6) {
        return value; 
      }
      else if (match && value.length > 6) {
        const countryCode = match[1].toUpperCase();

        // Always format as XX/RA/
        prefix = countryCode + "/RA/";

        // Remove the matched part from the value
        value = value.slice(match[0].length);

        // Remove all non-digit characters except a hyphen at the end
        let digitsOnly = value.replace(/[^0-9]/g, "");

        // Check if user already typed a hyphen at the end
        let endsWithHyphen = value.endsWith("-");

        // Insert hyphen after 5 digits if missing
        if (digitsOnly.length > 5 && !endsWithHyphen) {
          digitsOnly = digitsOnly.slice(0, 5) + "-" + digitsOnly.slice(5, 7);
        }

        // If user already typed hyphen at the end, preserve it
        if (endsWithHyphen && digitsOnly.length >= 5 && digitsOnly[5] !== "-") {
          digitsOnly = digitsOnly.slice(0, 5) + "-" + digitsOnly.slice(5);
        }

        return prefix + digitsOnly;
      }
      if(value.length > 2 && /^[0-9]+$/.test(value)) {
        prefix = `${this.companyCountry}/RA/`;
        value = value.replace(/^([A-Z]{2})?RA\/?/i, ""); // remove stray RA
        return prefix + value;
      }

      if (value.length > 6 ) {
        prefix = `${this.companyCountry}/RA/`;
        value = value.replace(/^([A-Z]{2})?RA\/?/i, ""); // remove stray RA
        return prefix + value;
      } else {
        return value;
      }

    },
    formatAhNumber(input) {
        if (!input) return '';

        let value = input.toUpperCase();

        let match = value.match(/^([A-Z]{2})\/?AH\/?/i);

        // Already has a valid AH prefix
        if (match && value.length > 6) {
            const countryCode = match[1].toUpperCase();
            const prefix = countryCode + "/AH/";

            // Remove the matched prefix
            value = value.slice(match[0].length);

            // Keep digits only
            let digitsOnly = value.replace(/[^0-9]/g, "");

            // AH format: exactly/at most 5 digits, no hyphen
            digitsOnly = digitsOnly.slice(0, 5);

            return prefix + digitsOnly;
        }

        // User entered only numbers
        if (/^[0-9]+$/.test(value)) {
            const prefix = `${this.companyCountry}/AH/`;

            // AH format: maximum 5 digits
            return prefix + value.slice(0, 5);
        }

        // User entered something longer / malformed
        if (value.length > 6) {
            const prefix = `${this.companyCountry}/AH/`;

            // Remove possible country/AH prefix
            value = value.replace(/^([A-Z]{2})?\/?AH\/?/i, "");

            // Keep digits only
            value = value.replace(/[^0-9]/g, "");

            // AH format: maximum 5 digits
            return prefix + value.slice(0, 5);
        }

        return value;
    },
    checkExtension(mail) {
      if (mail.endsWith("#")) {
        return false; // skip extension check if ends with "#"
      }

      const domain = mail.split("@").pop().trim().toLowerCase();

      // Exact domain match, or a subdomain of a listed domain (e.g. mail.yopmail.com)
      const inList = GENERIC_EMAIL_DOMAINS.has(domain) ||
        [...GENERIC_EMAIL_DOMAINS].some(d => domain.endsWith("." + d));

      const brandMatch = GENERIC_BRAND_KEYWORDS.some(brand => domain.includes(brand));

      return inList || brandMatch;
    }
  }
}
</script>

